import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useResourcesContext, useEmpresa } from "app/contexts";
import { Container } from "app/components/container";
import { Row } from "app/components/row";
import { Column } from "app/components/column";
import { CardHeader } from "app/components/card-header";
import { CardBody } from "app/components/card-body";
import { CardFooter } from "app/components/card-footer";
import { Textarea } from "app/components/textarea";
import { useEffect } from "react";
import { DFlexResponsive } from "app/components/d-flex-responsive";
import { Button } from "app/components/button";
import { Checkbox } from "app/components/checkbox";
import { ConditionalButton } from "app/components/buttons";
import { RouteError } from "app/components/route-error";
import { Autocomplete, TextField } from "@mui/material";
import toast from "react-hot-toast";

const initialState = {
  actividad_economica_id: 0,
  actividad_economica_detalles: "",
  actividad_economica_principal: false,
};

export function ActividadEconomicaForm() {
  const params = useParams();
  const navigate = useNavigate();

  const { actividadesEconomicas } = useResourcesContext();

  const { addActividad, getActividad, updateActividad } = useEmpresa();

  const [state, setState] = useState(initialState);

  useEffect(() => {
    try {
      if (!!params.index) {
        const actividad = getActividad(parseInt(params.index));

        setState(actividad);
      }
    } catch (error) {
      console.log(error.message);
    }
  }, [params.index, getActividad]);

  const [options] = useState(() =>
    actividadesEconomicas.map((actividad_economica) => ({
      label: `${actividad_economica.actividad_economica_id} - ${actividad_economica.actividad_economica_descripcion}`,
      ...actividad_economica,
    }))
  );

  const [value, setValue] = useState(null);

  useEffect(() => {
    const option = options.find(
      (option) => option.actividad_economica_id === state.actividad_economica_id
    );

    setValue(option || null);
  }, [options, state.actividad_economica_id]);

  function handleSubmit(e) {
    e.preventDefault();
    try {
      if (!!params.index) {
        const updated = updateActividad(parseInt(params.index), state);

        if (updated) {
          toast.success("¡Actividad económica actualizada!");

          return navigate("../../");
        }
      } else {
        const added = addActividad(state);

        if (!!added) {
          toast.success("¡Actividad económica agregada!");

          return navigate("../../");
        }
      }
    } catch (error) {
      toast.error(error.message);
    }
  }

  if (!!state.error) {
    return <RouteError message={state.error.message} navigateTo="../../" />;
  }

  return (
    <div className="col-sm-12 col-xl-8 offset-xl-2">
      <form className="card" onSubmit={handleSubmit}>
        <CardHeader
          header={`${params.index ? "Editar" : "Agregar"} actividad economica`}
        />

        <CardBody>
          <Container>
            <Row>
              <Column>
                <Autocomplete
                  value={value}
                  options={options}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Actividad económica"
                      required
                    />
                  )}
                  onChange={(e, value) => {
                    setValue(value);

                    setState((state) => ({
                      ...state,
                      actividad_economica_id:
                        value?.actividad_economica_id || 0,
                    }));
                  }}
                />
              </Column>

              <Column>
                <Textarea
                  minHeight={150}
                  placeholder="Detalles o descripción de la actividad económica"
                  value={state.actividad_economica_detalles}
                  onChange={(e) => {
                    setState((state) => ({
                      ...state,
                      actividad_economica_detalles: e.target.value,
                    }));
                  }}
                />
              </Column>

              <Column>
                <Checkbox
                  label="¿Es una actividad económica principal?"
                  checked={state.actividad_economica_principal}
                  onChange={(e) => {
                    setState((state) => ({
                      ...state,
                      actividad_economica_principal: e.target.checked,
                    }));
                  }}
                />
              </Column>
            </Row>
          </Container>
        </CardBody>

        <CardFooter>
          <DFlexResponsive justifyContent="end">
            <ConditionalButton
              type="submit"
              condition={!params.index}
              titleWhenTrue="Agregar"
              titleWhenFalse="Actualizar"
            />

            <Button
              color="secondary"
              outline
              title="Cancelar"
              onClick={() => navigate("../../")}
            />
          </DFlexResponsive>
        </CardFooter>
      </form>
    </div>
  );
}
